import {createSelector} from 'reselect';
import MessageType from '../../../../enums/MessageType';
import Language from '../../../lang/language';
import {isInApp} from '../../../utils/user-agent';
import {getSettings, getSiteCode} from '../../selectors';

export const getApplePayMessage = createSelector(
  [getSettings, getSiteCode],
  (settings, siteCode) => {
    let translationKey = 'payments.visa.and.mastercard.only';
    
    if (Language.doesTranslationExist(`${translationKey}.${siteCode}`)) {
      translationKey = `${translationKey}.${siteCode}`;
    }
    
    return (settings?.apple_pay_card_types ? {
      type: MessageType.INFO,
      translationKey,
    } : null);
  },
);

export const getShouldHideApplePay = state => !state.payment.isApplePayAvailable
  || (isInApp() && getSettings(state)?.should_hide_apple_pay_in_app);
